import { VtProjectStarter } from '@vt/projects'
import { getEnvConfig, Ky } from '@vt/utils'
import { LocalStorage } from '@ow/lowdb'

import platformData from './platform'

const config = getEnvConfig(platformData)

const PROJECT_NAME = process.env.REACT_APP_PROJECT
const ENV = process.env.REACT_APP_DEP || 'dev'

// new VtProjectStarter({platformData})  platformData参数 与config参数是不是有点重复
export const vtProject = new VtProjectStarter({})

export const initProject = function () {
  return vtProject.init({
    config,
    httpAdapter: new Ky({
      getToken: () => vtProject.getToken(),
    }),
    lowAdapter: new LocalStorage(`project-${PROJECT_NAME}-${ENV}`),
    amapKey: '0e4f7b5e424e7db93755cb5d48e71a75',
  })
}
